import { NgClass } from '@angular/common';
import { Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../../../ui/api/action.component';
import { ResultComponent } from '../../../../ui/api/result.component';

@Component({
    selector: 'wishlist-remove',
    templateUrl: 'wishlist-remove.component.html',
    styleUrl: './wishlist-remove.component.scss',
    standalone: true,
    imports: [ActionComponent, NgClass, ResultComponent, TranslatePipe]
})
export class WishlistRemoveComponent extends WishlistToggleComponentDef implements OnInit {
    wrapButton = input<boolean>();

    protected destroyRef = inject(DestroyRef);

    override ngOnInit(): void {
        super.ngOnInit();

        this.status.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.detectChanges());
    }

    override removeItem(): void {
        super.removeItem();
        this.detectChanges();
    }
}
